// plan-11 S04: service worker registration — bible §28

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return

  navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(() => {
    console.log('service worker: armed.')

    // detect new SW taking over
    let reloadOffered = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadOffered) return
      reloadOffered = true

      // stream a line into the terminal
      const history = document.querySelector('.vt-history') as HTMLElement | null
      if (history) {
        const line = document.createElement('div')
        line.className = 'vt-line-oracle'
        line.style.color = 'var(--vt-green-dim)'
        line.textContent = '> consensus refreshed. reload pending.'
        history.appendChild(line)
      }

      // offer reload chip in status bar chip-row
      const chipRow = document.getElementById('vt-sb-chip-row')
      if (chipRow) {
        const chip = document.createElement('span')
        chip.textContent = '[ reload ]'
        chip.className = 'vt-sb-chip'
        chip.setAttribute('role', 'button')
        chip.setAttribute('tabindex', '0')
        chip.style.cssText = 'cursor:pointer;color:var(--vt-amber);'
        chip.addEventListener('click', () => window.location.reload())
        chipRow.appendChild(chip)
      }
    })
  }).catch(() => {
    // SW registration failed — site still works without it
  })
}
